import React from 'react';

import Cart from '../../assets/images/empty-cart.svg';

export default function BnplLoanError({ className }) {
  return (
    <div className={`${className} error-container`}>
      <div className={`${className}__error-image-container`}>
        <img className={`${className}__error-image`} src={Cart} alt="cart-img" />
      </div>
      <div className={`${className}__error-text`}>
        Unfortunately, <br /> we’re unable to offer you <br /> financing today.
      </div>
    </div>
  );
}
